import { render, staticRenderFns } from "./post.vue?vue&type=template&id=025036c4&scoped=true"
import script from "./post.vue?vue&type=script&lang=js"
export * from "./post.vue?vue&type=script&lang=js"
import style0 from "./post.vue?vue&type=style&index=0&id=025036c4&prod&scoped=true&lang=css"
import style1 from "./post.vue?vue&type=style&index=1&id=025036c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025036c4",
  null
  
)

export default component.exports